<template>
  <div id="app" :class="{ hidden: !showCaption }">
    <navigation v-if="showCaption && projects.length > 0"></navigation>
    <div
      v-if="showCaption"
      :class="{ click: clickable }"
      id="caption"
      @click="openInfo"
      v-html="caption"
    ></div>
    <div v-if="showInfo" class="overlay info-box" @click="showInfo = false">
      <div class="info-close" @click="showInfo = false">
        CLOSE
      </div>
      <div v-html="info" @click.stop="showInfo = true"></div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
const Navigation = () =>
  import(/* webpackChunkName: "Navigation" */ "@/components/Navigation.vue");
export default {
  name: "App",
  metaInfo() {
    return {
      title: "Rita Vitorelli",
      titleTemplate: "Rita Vitorelli" + " %s"
    };
  },
  components: {
    Navigation
  },
  data() {
    return {
      caption: "",
      showCaption: true,
      showInfo: false,
      uid: "",
      info: "",
      clickable: false
    };
  },
  mounted() {
    this.$root.$on("changeCaption", this.changeCaption);
    this.$root.$on("toggleCaption", this.toggleCaption);
  },
  computed: mapState(["site", "projects"]),
  created() {
    this.$store.dispatch("loadSite");
    this.$store.dispatch("loadProjects");
  },
  methods: {
    openInfo() {
      if (this.clickable) {
        let project = this.projects.filter(project => project.uid === this.uid);
        this.info = project[0].description;
        this.showInfo = true;
      }
    },
    changeCaption(payload, uid, showinfo) {
      this.caption = payload;
      this.uid = uid;
      this.clickable = showinfo;
    },
    toggleCaption() {
      this.showCaption = !this.showCaption;
    }
  }
};
</script>

<style lang="scss">
@import "node_modules/reset-css/sass/_reset";
* {
  box-sizing: border-box;
}
:root {
  --fs: 1.4rem;
  --lh: calc(1.15 * 1.4rem);
  --color: rgb(0, 0, 0);
  --hover: rgb(150, 150, 150);
  @media only screen and (max-width: 768px) {
    --fs: 1.2rem;
    --lh: calc(1.15 * 1.2rem);
  }
}

a,
a:active,
a:hover,
a:visited {
  color: var(--color);
  text-decoration: none;
  &:hover {
    color: var(--hover);
  }
}

body,
html {
  position: fixed;
  width: 100%;
  height: 100%;
  font-size: var(--fs);
  line-height: var(--lh);
}

#app {
  width: 100%;
  height: 100%;
  position: fixed;
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  img {
    width: 100%;
  }
  #caption {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0.25rem;
    z-index: 1;
    &.click {
      cursor: pointer;
    }
  }
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    z-index: 2;
    background: white;
    padding: 3rem 0.25rem 0.25rem;
    cursor: default;
  }
  .info-box {
    z-index: 4;
    background: white;
    padding: 0.25rem 0.25rem;
    cursor: default;
    .info-close {
      margin-bottom: var(--lh);
      cursor: pointer;
    }
  }
  .up {
    cursor: n-resize !important;
  }
  .down {
    cursor: s-resize !important;
  }
  .left {
    cursor: w-resize !important;
  }
  .right {
    cursor: e-resize !important;
  }
  .hide {
    cursor: zoom-in;
  }
  &.hidden {
    .hide {
      cursor: zoom-out;
    }
  }
}
</style>
